import { OrgsFilterParams } from 'api/Orgs/types';

const orgsUrl = 'organizations';
const orgsListUrl = (filter: OrgsFilterParams) => {
  const { model, modelApi } = filter;
  return [
    orgsUrl,
    `?named_models=${model}`,
    `&model_api_names=${modelApi}`,
  ].join('');
};
const orgItemUrl = (orgId: string) => `${orgsUrl}/${orgId}`;
const orgModelsUrl = (orgId: string) => `${orgItemUrl(orgId)}/models`;
const orgModelsPermissionsUrl = (orgId: string) => `${orgItemUrl(orgId)}/models_permissions`;
const orgSftpUsersUrl = (orgId: string) => `${orgItemUrl(orgId)}/sftp_users`;
const orgGenerateApiKeyUrl = (orgId: string) => `${orgItemUrl(orgId)}/generate-api-key`;
const orgSftpUserItemUrl = (orgId: string, sftpUserId: string) => `${orgSftpUsersUrl(orgId)}/${sftpUserId}`;
const orgSftpUserSshKeysUrl = (orgId: string, sftpUserId: string) => `${orgSftpUserItemUrl(orgId, sftpUserId)}/ssh_keys`;
const orgSftpUserSshKeyItemUrl = (orgId: string, sftpUserId: string, sshKeyId: string) => `${orgSftpUserSshKeysUrl(orgId, sftpUserId)}/${sshKeyId}`;
const orgWebhooksInfo = (orgId: string) => `${orgItemUrl(orgId)}/webhooks-info`;
const orgWebhooksGenerateSecret = (orgId: string) => `${orgItemUrl(orgId)}/generate-webhooks-secret`;
const orgWebhooksTest = (orgId: string, webhookId: string) => `${orgItemUrl(orgId)}/webhooks/${webhookId}/test`;

export default {
  orgsUrl,
  orgsListUrl,
  orgItemUrl,
  orgModelsUrl,
  orgModelsPermissionsUrl,
  orgSftpUsersUrl,
  orgGenerateApiKeyUrl,
  orgSftpUserItemUrl,
  orgSftpUserSshKeysUrl,
  orgSftpUserSshKeyItemUrl,
  orgWebhooksInfo,
  orgWebhooksGenerateSecret,
  orgWebhooksTest,
};
